export default function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}


//////////////////
// WEBPACK FOOTER
// /Users/francescoamici/Sites/woliba.it/web/app/themes/woliba/node_modules/swiper/esm/components/core/loop/loopDestroy.js
// module id = 65
// module chunks = 0